'use client';

import Link from 'next/link';

const INCLUDED = [
  '10 keyword watches',
  'Monitor company or client names',
  'Alerts when new cases appear against a name',
  'Covers district courts, High Courts, Supreme Court, NCLT, ITAT, SAT & consumer commissions',
  'One-click add found cases to tracking',
];

/**
 * Case Discovery add-on banner. Rendered between the tier cards and the FAQ —
 * visually distinct from tier cards (horizontal, "Add-on" badge, two price points).
 */
export default function DiscoveryAddonSection() {
  return (
    <section className="px-4 pb-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-2xl border border-indigo-200 bg-gradient-to-r from-indigo-50 via-white to-violet-50 p-7 sm:p-9">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
            {/* Left: pitch + included list */}
            <div className="max-w-xl">
              <span className="inline-flex items-center rounded-full bg-gradient-to-r from-indigo-600 to-violet-600 px-3 py-1 text-[11px] font-semibold text-white shadow-sm">
                Add-on
              </span>
              <h2 className="mt-3 text-2xl font-bold text-slate-900">
                Case Discovery
              </h2>
              <p className="mt-2 text-sm text-slate-600">
                Watch up to 10 names — your company, your clients — and get alerted
                the moment a new case naming them appears in the official court
                record. Each watch is scoped to one forum of your choice.
              </p>
              <ul className="mt-5 grid gap-2.5 sm:grid-cols-2">
                {INCLUDED.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-slate-700">
                    <svg
                      className="mt-0.5 h-4 w-4 flex-shrink-0 text-indigo-500"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: pricing on request */}
            <div className="flex w-full flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-sm lg:w-auto lg:min-w-[22rem]">
              <p className="text-xs font-semibold uppercase tracking-wide text-indigo-600">
                Pricing on request
              </p>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">
                Tell us the names you want to watch and the forums that matter to you — we&apos;ll
                recommend one clear plan for your requirements.
              </p>
              <Link
                href="/contact"
                className="mt-4 block w-full rounded-lg bg-gradient-to-r from-indigo-600 to-violet-600 px-4 py-2.5 text-center text-sm font-semibold text-white shadow-sm transition-shadow hover:shadow-md"
              >
                Contact us for pricing
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
